// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__nAMkx","bodyContainer":"styles_bodyContainer__79rM5","title":"styles_title__Xuz5-"};